import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useRef } from 'react'
import { Button } from '~/components/ui/button'
import BlogCard from '../Card/BlogCard';
import { getFormattedCountryName } from '~/lib/helpers/constants';
import { PAGE_SECTION_IDS, PAGE_SECTION_SCROLL_CLASS } from "~/lib/constants/pageSectionIds";

function BlogsSection({
  areaBlogs,
  heading,
  description,
  country,
  region
}: {
  areaBlogs: [];
  heading?: string;
  description?: string;
  country?: string;
  region?: string;
}) {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (dir: "left" | "right") => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: dir === "left" ? -300 : 300,
        behavior: "smooth",
      });
    }
  };

  return (
    <div id={PAGE_SECTION_IDS.blogs} className={`py-5 ${PAGE_SECTION_SCROLL_CLASS}`}>
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-semibold text-gray-900">{heading || "Latest News"}</h2>
          <p className="text-md text-gray-[#181818] mt-1">
            {/* Work smarter with curated insights and trends. */}
            {description || ` Explore trends, data, and tips shaping ${getFormattedCountryName(region)}’s dynamic office market`}
          </p>
        </div>
        <div className="hidden md:flex">
          <Button
            size="icon"
            variant="ghost"
            className="bg-gray-100 mr-3"
            aria-label='scroll left'
            onClick={() => scroll("left")}
          >
            <ChevronLeft />
          </Button>
          <Button
            size="icon"
            variant="ghost"
            aria-label='scroll right'
            className="bg-gray-100"
            onClick={() => scroll("right")}
          >
            <ChevronRight />
          </Button>
        </div>
      </div>

      <div className="relative mt-6">

        <div
          ref={scrollRef}
          className="flex overflow-x-auto space-x-3 scroll-smooth  scrollbar-hide"
        >
          {areaBlogs?.map((article: any,) => (
            <BlogCard country={country} article={article} key={article.id} className={'w-[300px]'} />
          ))}
        </div>


      </div>
    </div>
  )
}

export default BlogsSection